import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class TableModel extends ModeModelBase {
  override _name = 'table';
  override belongsTo = 'account';
  override parentIdAttribute = 'username';
  override attributes = [
    { name: 'name', default: '' },
    { name: 'schema', default: '' },
    { name: 'description', default: '' },
    { name: 'created_at', default: '' },
  ];
  override hasOne = [{ name: 'preview', idAttribute: 'id' }];
}

@Injectable({ providedIn: 'root' })
export class TableModelAccessor extends ModelAccessorBase<TableModel> {
  override name = 'table';
  override parentModel = 'account';
  override parentIdAttribute = 'username';
  override createModel(resource, opts?) {
    const model = new TableModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.table');
  }
}
